import { MilestoneTemplate } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getMilestoneTemplateList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(MilestoneTemplate.MilestoneTemplateBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getMilestoneTemplateObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${MilestoneTemplate.MilestoneTemplateBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addMilestoneTemplate(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(MilestoneTemplate.MilestoneTemplateBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getMilestoneOptions(data) {
    return new Promise((resolve, reject) => {
      axios
        .options(MilestoneTemplate.MilestoneTemplateBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateMilestoneTemplate(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${MilestoneTemplate.MilestoneTemplateBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateMilestone(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${MilestoneTemplate.MilestoneTemplateBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
